import {LOGIN_SUCCESS,LOGIN_FAIL,LOGOUT,USER_LOADED,AUTH_ERROR,CLEAR_ERRORS,MAIL_OK,MAIL_NOTOK,CLEAR_MAILERROR,PW_UPDATED,PW_ERROR,ROBOT_CHECKED,CODE_OK,CODE_ERR,RETRY_FAIL} from './authTypes';
import axios from 'axios';

export const loadUser = () => async (dispatch) => {
  try {
    const res = await axios.get('/api/auth');
    dispatch({type: USER_LOADED, payload: res.data});
  } catch (err) {
    dispatch({type: AUTH_ERROR, payload: 'auth token expired'});
  }
};

export const portalLogin = (formData) => async (dispatch) => {
  const config = {
    headers: {'content-Type': 'application/json'}
  };

  try {
    const res = await axios.post('/api/auth', formData, config);
    dispatch({type: LOGIN_SUCCESS, payload: res.data});
  } catch (err) {
    if(!err.response.data.msg) { //api server not reachable
      dispatch({type: LOGIN_FAIL, payload: 'api error'});
    } else {
      dispatch({type: LOGIN_FAIL, payload: err.response.data.msg});
    }
  }
};

export const retryFailed = () => ({type: RETRY_FAIL});

export const logout = () => ({type: LOGOUT});

export const clearErrors = () => ({type: CLEAR_ERRORS});

export const clearMailError = () => ({type: CLEAR_MAILERROR});

export const mailCheck = (mail) => async (dispatch) => {
  const config = {
    headers: {'content-Type': 'application/json'}
  };
  try {
    const res = await axios.post('/api/emailcheck', mail, config);
    dispatch({type: MAIL_OK, payload: res.data});
  } catch (err) {
    if(!err.response.data.msg) { //api server not reachable
      dispatch({type: MAIL_NOTOK, payload: 'api error'});
    } else {
      dispatch({type: MAIL_NOTOK, payload: err.response.data.msg});
    }
  }
};

export const robotChecked = () => ({type: ROBOT_CHECKED});

export const updatePassword = (formData) => async (dispatch) => {
  const config = {
    headers: {'content-Type': 'application/json'}
  };

  try {
    const res = await axios.post('/api/passchange', formData, config);
    dispatch({type: PW_UPDATED, payload: res.data});
  } catch (err) {
    if(!err.response.data.msg) { //api server not reachable
      dispatch({type: PW_ERROR, payload: 'api error'});
    } else {
      dispatch({type: PW_ERROR, payload: err.response.data.msg});
    }
  }
};

export const checkCode = (formData) => async (dispatch) => {
  const config = {
    headers: {'content-Type': 'application/json'}
  };
  try {
    await axios.post('/api/verifycode', formData, config);
    dispatch({type: CODE_OK});
  } catch (err) {
    dispatch({type: CODE_ERR});
  }
};

